export const getAppleSignUpDisabledMessage = (email: string): string => {
  if (email)
    return `Kindbody account with email ${email} doesn't exist. We currently do not support sign-up using Apple ID. To create an account, please choose an alternative method, such as Google SSO, or use your email address with a password.`;
  else
    return `Kindbody account doesn't exist. We currently do not support sign-up using Apple ID. To create an account, please choose an alternative method, such as Google SSO, or use your email address with a password.`;
};
